import { useRef, type ReactNode } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { AppHeader, PageShell } from '@/components/layout'
import { LogoutAction } from '@/pages/Profile/LogoutAction'
import { usePageScroll } from '@/hooks/usePageScroll'

export type RouteTemplateProps = {
  children: ReactNode
  title: string
  headerStart?: ReactNode
  headerCenter?: ReactNode
  headerEnd?: ReactNode
  back?: string
  padded?: boolean
  logout?: boolean
  orderDetails?: boolean
  restoreScroll?: boolean
}

// Route-level composition is mandatory; feature pages supply only their content.
export function RouteTemplate({ children, title, headerStart, headerCenter, headerEnd, back, padded = true, logout = false, orderDetails = false, restoreScroll = true }: RouteTemplateProps) {
  const navigate = useNavigate()
  const [search] = useSearchParams()
  const content = useRef<HTMLDivElement>(null)
  usePageScroll(content, restoreScroll)
  const orderRoute = search.get('source') ?? ''
  const backTarget = orderDetails
    ? (['order', 'archive', 'penalty'].includes(orderRoute) ? `/report/${orderRoute}` : '/report')
    : back
  const detailTitle = orderRoute === 'order' ? 'جزئیات فروش' : orderRoute === 'penalty' ? 'جزئیات جریمه' : 'جزئیات سفارش'

  return <PageShell padded={padded} header={<AppHeader
    start={headerStart ?? (orderDetails ? detailTitle : title)}
    center={headerCenter}
    onBack={backTarget ? () => navigate(backTarget) : undefined}
    end={logout ? <LogoutAction /> : headerEnd}
  />}>
    <div ref={content} className="chef-route-content">{children}</div>
  </PageShell>
}
